import { forwardRef } from "react";
import { MenuItem, createStyles, makeStyles, } from "@material-ui/core";
import { hoverColor } from "../utils/configuration";
const useStyles = makeStyles(() => createStyles({
    listItem: {
        borderBottom: "1px solid rgba(255, 255, 255, 0.25)",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        "&:hover": { background: hoverColor + " !important" },
        "&:focus-visible": { background: hoverColor + " !important" },
    },
}));
const StyledMenuItem = forwardRef((props, ref) => {
    const classes = useStyles();
    return (<MenuItem ref={ref} className={classes.listItem} {...props}>
      {props.children}
    </MenuItem>);
});
export default StyledMenuItem;
